import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategoryCards from './components/CategoryCards';
import HotTopics from './components/HotTopics';
import ArticleGrid from './components/ArticleGrid';
import Testimonial from './components/Testimonial';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/data';

const homepageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.name,
  url: 'https://www.51chigua.com',
  description: siteInfo.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.51chigua.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.name,
  url: 'https://www.51chigua.com',
  description: siteInfo.description,
  email: siteInfo.email,
  telephone: siteInfo.phone,
  address: {
    '@type': 'PostalAddress',
    streetAddress: siteInfo.address,
    addressCountry: 'CN',
  },
};

const webPageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${siteInfo.name} - 网红黑料每日大赛实时追踪 | 51吃瓜网站入口与在线观看`,
  description: siteInfo.description,
  url: 'https://www.51chigua.com',
  isPartOf: {
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'https://www.51chigua.com',
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageJsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageJsonLd) }} />
      <Navbar />
      <main>
        <HeroBanner />
        <CategoryCards />
        <HotTopics />
        <ArticleGrid />
        <Testimonial />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}